import {
  ApolloClient,
  InMemoryCache,
  NormalizedCacheObject,
} from '@apollo/client';
import { createPrismicLink } from 'apollo-link-prismic';
import combineQuery from 'graphql-combine-query';
import { DocumentNode } from 'graphql';
import {
  COOKIES_QUERY,
  FOOTER_QUERY,
  HEADER_QUERY,
  SEO_QUERY,
} from '../graphql/queries';
import { BasePageQuery, PageQuery } from '../graphql/model/PageQuery';

export const apolloClient: ApolloClient<NormalizedCacheObject> =
  new ApolloClient({
    link: createPrismicLink({
      repositoryName: process.env.NEXT_PUBLIC_PRISMIC_REPOSITORY_NAME as string,
      accessToken: process.env.NEXT_PUBLIC_PRISMIC_ACCESS_TOKEN,
    }),

    cache: new InMemoryCache(),
  });

export const defaultQueryResult = ({
  allHeaders,
  allFooters,
  allCookiess,
}: PageQuery<BasePageQuery>) => {
  return {
    header: allHeaders.edges[0].node,
    footer: allFooters.edges[0].node,
    cookies: allCookiess.edges[0].node,
  };
};

export const getPageQuery = (
  variables: { [x: string]: string | number | boolean },
  queryName: string,
  pageQuery?: any | any[]
): { query: DocumentNode; variables: any } => {
  const combine = combineQuery(queryName);
  let query = combine
    .add(HEADER_QUERY, { headerLang: variables.pageLang })
    .add(FOOTER_QUERY, { footerLang: variables.pageLang })
    .add(COOKIES_QUERY, { cookiesLang: variables.pageLang })
    .add(SEO_QUERY, { seoLang: variables.pageLang });

  if (!pageQuery) {
    return { query: query.document, variables: query.variables };
  }

  if (Array.isArray(pageQuery)) {
    pageQuery
      .filter((x) => x)
      .forEach((currentQuery) => {
        query = query.add(currentQuery, variables);
      });
  } else {
    query = query.add(pageQuery, variables);
  }

  return { query: query.document, variables: query.variables };
};

export const getQuery = (
  variables: { [x: string]: string | number | boolean | undefined },
  queryName: string,
  pageQuery: any | any[]
): { query: DocumentNode; variables: any } => {
  const combine = combineQuery(queryName);
  let query: any = null;

  if (Array.isArray(pageQuery)) {
    pageQuery
      .filter((x) => x)
      .forEach((currentQuery) => {
        query = query
          ? query.add(currentQuery, variables)
          : combine.add(currentQuery, variables);
      });

    return { query: query.document, variables: query.variables };
  } else {
    query = combine.add(pageQuery, variables);

    return { query: query.document, variables: query.variables };
  }
};
